module.exports = __webpack_public_path__ + "media/images/shop/play-icon-b12aae212c6eede841503337888d12f8.svg";